export const filterOptions = (value, options) => {
    if (!value) {
        return options;
    }
    const optionsFilter = options.filter(({ label }) => String(label).toLocaleLowerCase().includes(String(value).toLocaleLowerCase()));
    return optionsFilter;
};
export const findOptionByLabel = (label, options) => {
    return options.find(opt => String(opt.label) === String(label));
};
export const findOptionByValue = (value, options) => {
    return options.find(opt => String(opt.value) === String(value));
};
//# sourceMappingURL=filterOptions.js.map